import config from 'config';

export const handleErrors = (response: Response): Promise<any> => {
    if (!response.ok) {
        if (response.status === 401) {
            if (window.location.pathname !== config.loginPagePath) {
                window.location.assign(config.loginPagePath);
            }
        }
        if (response.status === 403) {
            if (window.location.pathname !== config.loginPagePath) {
                window.location.assign('/no-rights/');
            }
        }
        return Promise.reject(response);
    }
    return Promise.resolve(response);
};
